import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Permissions } from '@liveline/ll_node_common';
import { Action } from '@liveline/ll_node_common/lib/Permissions/types';
import { AbilityContext } from '../../components/shared/Can';

const ALWAYS_ACCESSIBLE = new Set(['dashboard', 'profile']);

interface RootState {
    userSelection: {
        facility: {
            livelineFacilityId?: string;
        };
    };
}

interface ScreenPermissionGateProps {
    children: React.ReactNode;
}

const ScreenPermissionGate: React.FC<ScreenPermissionGateProps> = ({ children }) => {
    const ability = useContext(AbilityContext);
    const location = useLocation();
    const facilityId = useSelector((state: RootState) => state?.userSelection?.facility?.livelineFacilityId);

    // Derive screen key from path: strip leading '/' and take first two segments.
    // e.g. /general_admin/users -> general_admin/users
    //      /general_admin/equipment/add -> general_admin/equipment
    const segments = location.pathname.replace(/^\//, '').split('/');
    const screenKey = segments.slice(0, 2).join('/');

    if (ALWAYS_ACCESSIBLE.has(screenKey)) {
        return <>{children}</>;
    }

    // When ability or facilityId is unavailable, allow access (mirrors menuItemIsDisabled behavior)
    if (!ability || !facilityId) {
        return <>{children}</>;
    }

    const canView = Permissions.checkAbility(ability, Action.VIEW, screenKey as any, { facilityId });

    if (!canView) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default ScreenPermissionGate;
